import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import Zone from "@insite/client-framework/Components/Zone";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { FooterContext } from "@insite/content-library/Pages/Footer";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import themeColors, { themeFontSizes, themeFontWeights, themeIndentSizes } from "@MasterBluePrint/Styles/variables";
import React, { FC } from "react";
import { css } from "styled-components";


interface OwnProps extends WidgetProps {
    extendedStyles?: FooterContainerStyles;
}

export interface FooterContainerStyles {
    widgetGridContainer?: GridContainerProps;
    logoGridItem?: GridItemProps;
    linkList1GridItem?: GridItemProps;
    linkList2GridItem?: GridItemProps;
    linkList3GridItem?: GridItemProps;
    linkList4GridItem?: GridItemProps;
    subscribeGridItem?: GridItemProps;
    socialLinksGridItem?: GridItemProps;
    siteMapLinksGridItem?: GridItemProps;
    richContentGridItem?: GridItemProps;
    logoWrapper?: InjectableCss;
}

export const footerContainerStyles: FooterContainerStyles = {
    widgetGridContainer: {
        gap: 0,
        css: css`
            background: ${themeColors.colorPrimary};
            position: relative;
            margin: 0 auto;
            box-shadow: 100em 0 0 0 ${themeColors.colorFooterBackground}, -100em 0 0 0 ${themeColors.colorFooterBackground};
            max-width: 1440px !important;
            padding: 0 .9375rem;
            align-items: center;
            z-index: 9;
            img {
                opacity: 1;
            }
            > div > div:first-child {
                margin: 0 .9375rem;
                padding-left: 0;
                padding-right: 0;
                padding-bottom: 0;
            }
            > div > div:last-child {
                padding: 0;
            }
            .mr-4,
            .mx-4 {
                margin-right: 1.5rem;
            }
            .mb-5,
            .my-5 {
                margin-bottom: 3rem;
            }
            .footerMainHeading > span {
                color: ${themeColors.colorSecondary};
                font-family: 'Roboto', sans-serif;
                font-size: 1.0625rem;
                font-weight: 500;
                line-height: 1.25rem;
                padding-bottom: .9375rem;
                border-bottom: 1px solid ${themeColors.colorBrandsSeeMore};
                padding-right: 6rem;
                &:hover {
                    color: ${themeColors.colorSecondary};
                    text-decoration: none;
                }
            }
            .footerSubHeading > span {
                color: ${themeColors.colorFooter};
                font-family: 'Roboto', sans-serif;
                font-size: ${themeFontSizes.size14};
                font-weight: 500;
                letter-spacing: -.014rem;
                line-height: 2.1875rem;
                &:hover {
                    color: ${themeColors.colorFooter};
                    text-decoration: none;
                }
            }
            ul {
                margin-top: .31250625rem;
                padding-left: 0;
            }
            ,
            ul li {
                list-style-type: none;
            }
            .logistics {
                font-weight: bold;
            }
            .logistics-li {
                padding-left: 1.25rem;
            }
            .assessments {
                font-weight: bold;
            }
            .assessments-li {
                padding-left: 1.25rem;
            }
            .slogan > span {
                opacity: .78;
                color: ${themeColors.colorWhite};
                font-family: 'Lato', sans-serif;
                font-size: ${themeFontSizes.size15};
                letter-spacing: 0;
                line-height: 1.9375rem;
                &:hover {
                    color: ${themeColors.colorFooter};
                    text-decoration: underline;
                }
            }

            .contact-details {
                display: flex;
            }
            .contact-number {
                color: ${themeColors.colorFooter};
                font-family: Lato;
                font-size: 1.25rem;
                letter-spacing: 0;
            }
            .social-tt {
                display: flex;
            }
            .social-tt-icons {
                padding: .9375rem 1.25rem 0 0;
            }
            .logistics a {
                font-weight: bold;
            }
            .logistics-li {
                padding-left: 1.25rem;
            }
            .assessments a {
                font-weight: bold;
            }
            .assessments-li {
                padding-left: 1.25rem;
            }
            .footer-copyright-section {
                padding: .9375rem;
                background: ${themeColors.colorFooterNew};
                margin: 0 !important;
            }
            .footer-copyright-section p {
                max-width: 1440px;
                margin: 0 auto;
                color: ${themeColors.colorFooter};
            }
            .marketo-heading {
                margin: .31250625rem 0 .625rem;
            }
            .contact-details {
                display: inline-block;
                vertical-align: top;
                line-height: 1;
                margin-left: .9375rem;
            }
            .contact-number {
                line-height: 1;
            }
            .contact-icon {
                display: inline-block;
                vertical-align: top;
            }
            .footer-logo {
                margin-left: 0;
            }
            .f-logo-text {
                opacity: .78;
                color: ${themeColors.colorWhite};
                font-family: 'Lato', sans-serif;
                font-size: .9375rem;
                letter-spacing: 0;
                line-height: 1.9375rem;
            }
            @media screen and (max-width: 1024px) and (min-width: 768px) {
                box-shadow: 25em 0 0 0 ${themeColors.colorPrimary}, -25em 0 0 0 ${themeColors.colorPrimary};
            }
            @media (max-width: 767px) {
                box-shadow: 5em 0 0 0 ${themeColors.colorPrimary}, -5em 0 0 0 ${themeColors.colorPrimary};
                padding-top: 4.375rem;
                padding-left: 1.5625rem;
                padding-right: 1.5625rem;
                .contact-details {
                    padding-top: 0 !important;
                    padding-left: 0 !important;
                    line-height: 1 !important;
                }
                .footer-copyright-section {
                    margin: 0 !important;
                    box-shadow: 5em 0 0 0 ${themeColors.colorFooterNew}, -5em 0 0 0 ${themeColors.colorFooterNew};
                }
                .marketo-heading {
                    padding-left: .9375rem;
                }
                .mob-pl-15 {
                    padding-left: .9375rem;
                }
                .mob-ml-15 {
                    margin-left: .9375rem;
                }
                > div > div:first-child {
                    margin: 0;
                }
                > div > div {
                    width: 100%;
                    max-width: 100%;
                    flex-basis: 100%;
                    padding: 0;

                    .widget-richcontent {
                        margin-top: 3.125rem;
                    }
                }
                .footer-logo {
                    margin-left: .9375rem;
                }
                .f-logo-text {
                    display: none;
                }
                .widget-richcontent-section-article ul {
                    display: none;
                }
                .widget-richcontent-section-heading a,
                .widget-richcontent-section-heading span {
                    display: block;
                    width: 100%;
                    padding-right: 0;
                    border-bottom: 1px solid rgb(83, 94, 100, .5);
                }
                .widget-richcontent-section-heading {
                    overflow: hidden;
                }
                .widget-richcontent-section-heading span,
                .footer-content-heading {
                    padding: .9375rem;
                }
                .footer-content-heading {
                    padding-top: 4.375rem;
                }
                .contact-details {
                    padding-top: .9375rem;
                    padding-left: .9375rem;
                    padding-right: .9375rem;
                }
                .social-tt {
                    padding-bottom: 3.125rem;
                    padding-left: .9375rem;
                    padding-right: .9375rem;
                }
                .contact-number {
                    line-height: 1;
                }
                .tracking-wide {
                    display: none;
                }
                .spacing-adjust {
                    padding-top: 1.5625rem;
                }
                .footer-logo {
                    position: relative;
                    top: -.625rem;
                }
            }
        `,
    },
    logoGridItem: {
        width: 12,
        css: css`
            padding-top: 3.5rem;
            padding-bottom: 1.5rem;
            border-bottom: 1px solid ${themeColors.colorBrandsSeeMore};
            color: ${themeColors.colorWhite};

            div,
            a {
                color: ${themeColors.colorWhite};
            }
        `,
    },
    linkList1GridItem: {
        width: [8, 8, 6, 3, 3],
    },
    linkList2GridItem: {
        width: [8, 8, 6, 3, 3],
    },
    linkList3GridItem: {
        width: [8, 8, 6, 3, 3],
    },
    linkList4GridItem: {
        width: [8, 8, 6, 3, 3],
    },
    subscribeGridItem: {
        width: [12, 12, 8, 4, 4],
    },
    socialLinksGridItem: {
        width: 12,
    },
    siteMapLinksGridItem: {
        width: 12,
    },
    richContentGridItem: {
        width: 12,
        css: css`
            color: ${themeColors.colorFooter};
            font-family: 'Roboto', sans-serif;
            font-size: ${themeFontSizes.size14};
            font-weight: 500;
            letter-spacing: -.014rem;
            line-height: 2.1875rem;
            background-color: ${themeColors.colorFooterNew};
            padding: .9375rem;
            box-shadow: 10em 0 0 0 ${themeColors.colorFooterNew}, -10em 0 0 0 ${themeColors.colorFooterNew};
        `,
    },
    logoWrapper: {
        css: css`
            width: 100%;
            padding-bottom:1rem;
            margin-bottom:1rem;
        `,
    },
};

const FooterContainer: FC<OwnProps> = ({ id, extendedStyles }) => {
    const [styles] = React.useState(() => mergeToNew(footerContainerStyles, extendedStyles));
    return (
        <GridContainer {...styles.widgetGridContainer}>
            <GridItem {...styles.logoGridItem}>
                <StyledWrapper {...styles.logoWrapper}>
                    <Zone zoneName="RichContentHeading" contentId={id} />
                </StyledWrapper>
            </GridItem>
            <GridItem {...styles.linkList1GridItem}>
                <Zone zoneName="LinkList1" contentId={id} />
            </GridItem>
            <GridItem {...styles.linkList2GridItem}>
                <Zone zoneName="LinkList2" contentId={id} />
            </GridItem>
            <GridItem {...styles.linkList3GridItem}>
                <Zone zoneName="LinkList3" contentId={id} />
            </GridItem>
            <GridItem {...styles.linkList4GridItem}>
                <Zone zoneName="LinkList4" contentId={id} />
            </GridItem>
            {/* <GridItem {...styles.subscribeGridItem}>
                <Zone zoneName="Subscribe" contentId={id} />
            </GridItem> */}
            {/* <GridItem {...styles.socialLinksGridItem}>
                <Zone zoneName="SocialLinks" contentId={id} />
            </GridItem>
            <GridItem {...styles.siteMapLinksGridItem}>
                <Zone zoneName="SiteMapLinks" contentId={id} />
            </GridItem> */}
            <GridItem {...styles.richContentGridItem}>
                <Zone zoneName="RichContentCopyright" contentId={id} />
            </GridItem>
        </GridContainer>
    );
};

const footerContainer: WidgetModule = {
    component: FooterContainer,
    definition: {
        group: "Footer",
        allowedContexts: [FooterContext],
    },
};

export default footerContainer;
